// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2h1Jp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3kyBm","obliqueLine":"membershipbadge_obliqueLine__17j5A"};